import $ from "jquery";
import "slick-slider";



function parseBool(value, fallback) {
  if (value === "true") return true;
  if (value === "false") return false;
  return fallback;
}

function parseIntSafe(value, fallback) {
  const n = parseInt(value, 10);
  return Number.isFinite(n) ? n : fallback;
}

export default function initHeroSlideshow(el) {
  // Don't run inside Sitecore Experience Editor — authors need static slides.
  if ($("body").hasClass("is-page-editor")) {
    return;
  }

  const $track = $(el);
  if ($track.hasClass("slick-initialized")) {
    return;
  }

  const slideCount = $track.children(".hero-slideshow__slide").length;
  if (slideCount === 0) {
    return;
  }

  // Read author-set behavior from the parent <section>.
  const $section = $track.closest(".hero-slideshow");
  const autoplay =
    slideCount > 1 &&
    parseBool($section.attr("data-autoplay"), true);
  const autoplaySpeed = parseIntSafe(
    $section.attr("data-autoplay-speed"),
    5000,
  );
  const showArrows =
    slideCount > 1 &&
    parseBool($section.attr("data-show-arrows"), true);
  const showDots =
    slideCount > 1 &&
    parseBool($section.attr("data-show-dots"), false);

  const prefersReducedMotion =
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const config = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: slideCount > 1,
    fade: true,
    cssEase: "linear",
    speed: prefersReducedMotion ? 0 : 600,
    autoplay: autoplay && !prefersReducedMotion,
    autoplaySpeed,
    arrows: showArrows,
    dots: showDots,
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: false,
    // Slick's built-in keyboard handler (Left/Right arrow keys) is enabled
    // by default but we set it explicitly so it can never be silently
    // disabled by a global slick config change. Keyboard-only users rely
    // on this to navigate slides.
    accessibility: true,
    prevArrow: `
      <button type="button" class="slick-prev" aria-label="Previous slide">
        <span class="icon" aria-hidden="true">
          <i class="fas fa-chevron-left"></i>
        </span>
      </button>`,
    nextArrow: `
      <button type="button" class="slick-next" aria-label="Next slide">
        <span class="icon" aria-hidden="true">
          <i class="fas fa-chevron-right"></i>
        </span>
      </button>`,
  };

  $track.slick(config);

  // ---- ARIA: announce current slide on every change ----
  // Slick's default arrow ARIA labels are static ("Previous slide" /
  // "Next slide"), which gives screen-reader users no idea where they
  // are in the carousel. We update the labels with "(slide X of Y)" on
  // every transition so the next focus on an arrow announces the new
  // context. The `aria-live="polite"` region on the track (set in the
  // Razor view) also announces the active slide's content for users who
  // don't interact with the arrows.
  function updateArrowLabels(currentIndex) {
    const total = slideCount;
    const current = currentIndex + 1; // 0-based -> 1-based
    const $prev = $track.find(".slick-prev");
    const $next = $track.find(".slick-next");
    $prev.attr(
      "aria-label",
      `Previous slide (showing slide ${current} of ${total})`,
    );
    $next.attr(
      "aria-label",
      `Next slide (showing slide ${current} of ${total})`,
    );
  }
  updateArrowLabels(0);
  $track.on("afterChange", (_event, _slick, currentSlide) => {
    updateArrowLabels(currentSlide);
  });

  // ---- Cleanup: destroy slick if the element is removed ----
  // Without this the slick instance and its document-level event
  // handlers leak whenever the rendering is swapped out (AJAX nav,
  // Sitecore personalization re-render, Storybook hot-reload, etc.).
  //
  // A MutationObserver watching the immediate parent for child removal
  // is the most robust trigger because:
  //   1. It fires synchronously on DOM mutation, so cleanup happens
  //      before the next slick init runs.
  //   2. It survives jQuery's `.remove()` AND raw DOM API removal.
  //   3. No global event listeners, no polling.
  const parent = el.parentNode;
  if (parent && typeof window.MutationObserver === "function") {
    const observer = new window.MutationObserver(() => {
      if (!document.body.contains(el)) {
        if ($track.hasClass("slick-initialized")) {
          $track.off("afterChange");
          $track.slick("unslick");
        }
        observer.disconnect();
      }
    });
    observer.observe(parent, { childList: true });
  }
}
